import React from "react";
import FeatureBadge from "./FeatureBadge";

const FeatureBadges = () => (
  <div className="flex flex-wrap justify-center mt-12 gap-4">
    <FeatureBadge
      text="All Sri Lanka Coverage"
      link="/properties?listing_type=rent&page=1"
    />
    <FeatureBadge
      text="Colombo 03 Properties"
      link="/properties?page=1&location=colombo-03"
    />
    <FeatureBadge
      text="Colombo 04 Properties"
      link="/properties?page=1&location=colombo-04"
    />
  </div>
);

export default FeatureBadges;
